import { zodResolver } from '@hookform/resolvers/zod'
import { ArrowLeft } from 'lucide-react'
import { FC, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useLocation, useNavigate } from 'react-router-dom'
import appStore from 'src/assets/product-config/app-store.png'
import { api } from 'src/services/api'
import { z } from 'zod'
import { useNotification } from '../../hooks/notification'
import { service } from '../../services/ajio'
import { FormInput, FormSelectInput, GradientButton } from './components'
import './styles.css'

import background from 'src/assets/product-config/background-signin.png'
import android from 'src/assets/product-config/google-play.png'

const FormSchema = z.object({
  cnpj: z.string().nonempty('Insira o CNPJ.'),
  email: z
    .string()
    .nonempty('Insira um e-mail')
    .email('O e-mail fornecido não é válido.'),
  companyName: z.string().nonempty('Insira a Razão Social.'),
  fantasyName: z.string().nonempty('Insira o Nome Fantasia.'),
  phone: z.string().nonempty('Insira o Telefone.'),
  foundationDate: z.string().nonempty('Insira a Data de fundação.'),
  legalNature: z.string().nonempty('Insira a Natureza jurídica.'),
  CNAE: z.string().nonempty('Insira o CNAE.'),
  monthlyRevenue: z.string().nonempty('Insira sua Receita média mensal.'),
  patrimony: z.string().nonempty('Insira seu Patrimônio.'),
  shareCapital: z.string().nonempty('Insira seu Capital Social.'),
  monthlyBilling: z.string().nonempty('Insira seu Faturamento Mensal.'),
})

type FormInputs = z.infer<typeof FormSchema>

export const InsertAccountDataPj: FC = () => {
  const location = useLocation()

  const { accountType } = location.state

  const { setOpenNotification } = useNotification()

  const [loading, setLoading] = useState(false)

  const { control, handleSubmit, setValue } = useForm<FormInputs>({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      cnpj: '',
      email: '',
      companyName: '',
      fantasyName: '',
      phone: '',
      foundationDate: '',
      legalNature: '',
      CNAE: '',
      monthlyRevenue: '',
      patrimony: '',
      shareCapital: '',
      monthlyBilling: '',
    },
  })

  const navigate = useNavigate()

  const onSubmit = async (data: FormInputs) => {
    setLoading(true)
    try {
      const formatCNPJ = (cnpj: string) => {
        return cnpj.replace(/[^\d]/g, '')
      }
      const formattedCNPJ = formatCNPJ(data.cnpj)
      const response = await api.get(
        `graphic/verify/email/${data.email}/${formattedCNPJ}`
      )
      console.log(response)

      localStorage.setItem('@yntech:signup-data-01', JSON.stringify(data))
      setLoading(false)
      navigate('/create-account-wallet/choose-plan', {
        state: { accountType },
      })
    } catch (err) {
      setLoading(false)
      setOpenNotification({
        title: 'Alerta',
        notification: ' E-mail ou Cnpj já esta cadastrado.',
        type: 'warning',
      })
    }
  }

  return (
    <div
      style={{
        backgroundImage: `url(${background})
`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
      }}
      className="w-full flex-col h-screen flex justify-center items-center gap-20"
    >
      <button
        onClick={() => navigate('/create-account-wallet/choose-account-type')}
        className="h-12 w-12 absolute left-10 top-10 flex items-center justify-center rounded-xl bg-zinc-950 shadow-sm"
      >
        <ArrowLeft size={22} color="white" />
      </button>
      <div className="flex flex-col absolute bottom-10 left-10">
        <span className="text-white text-xl font-bold">Baixe o nosso app,</span>
        <span className="text-white text-xl">
          disponível nas principais lojas
        </span>
        <div className="flex gap-2 mt-2">
          <img
            alt=""
            src={android}
            className="w-[150px] object-contain cursor-pointer"
          />
          <img
            alt=""
            src={appStore}
            className="w-[150px] object-contain cursor-pointer"
          />
        </div>
      </div>
      <div className="bg-black mr-10 self-end bg-opacity-40 rounded-3xl backdrop-filter backdrop-blur-md border border-gray-600 p-12 max-w-[50%] flex flex-col justify-center items-center">
        <div className="w-full ">
          <div className="w-full flex items-start gap-10">
            <p className="font-medium text-white text-2xl full-hd:text-2xl 3xl-hd:text-3xl qhd:text-4xl studio-laptop:text-5xl qhd-plus:text-6xl 4k:text-7xl 5k:text-8xl leading-7 mb-[2%]">
              Você está a poucos passos de uma <br />
              nova <strong>experiência financeira </strong>
            </p>

            <GradientButton
              title="1/7"
              tailwindStyles="bg-black text-white w-14 self-end"
              onClick={() => console.log('')}
            />
          </div>

          <p className="text-white p-texte font-light mt-2 mb-2 ">
            Todos os dados a seguir devem ser <br />
            obrigatoriamente do titular.
          </p>
          <form onSubmit={handleSubmit(onSubmit)}>
            {fields.map((item: any, index: number) => {
              return (
                <div key={item.id}>
                  {item.breakPoint === false && (
                    <Controller
                      name={item.id as any}
                      control={control}
                      render={({ field, fieldState }) => (
                        <FormInput
                          onBlur={async () => {
                            try {
                              if (item.id === 'cnpj') {
                                const formatedCNPJ = field?.value.replace(
                                  /\D/g,
                                  ''
                                )
                                const response = await service.get(
                                  `/auth/me/${formatedCNPJ}`
                                )
                                const info = response.data

                                if (!info) {
                                  setOpenNotification({
                                    notification: `Informações do CNPJ não encontradas`,
                                    title: `Erro`,
                                    type: 'error',
                                  })
                                  return
                                }

                                setValue('companyName', info.nome)
                                setValue('cnpj', info.cnpj)
                                setValue('email', info.email)
                                setValue('legalNature', info.natureza_juridica)
                                setValue('fantasyName', info.fantasia)
                                setValue('foundationDate', info.abertura)
                                setValue(
                                  'CNAE',
                                  info.atividade_principal[0].code
                                )
                                setValue('phone', info.telefone)
                                setValue('shareCapital', info.capital_social)
                              }
                            } catch (error) {
                              console.log(error)
                              return setLoading(false)
                            }
                          }}
                          onChangeText={(e) => field.onChange(e)}
                          style={{
                            height: '5.5vh',
                          }}
                          placeholder={item.placeholder}
                          required
                          value={field.value}
                          mask={item.mask}
                          errorMessage={fieldState.error?.message}
                        />
                      )}
                    />
                  )}

                  {item.breakPoint && (
                    <div className="flex items-center gap-5 justify-between">
                      {item.isDropdown && (
                        <Controller
                          name={item.id as any}
                          control={control}
                          render={({ field, fieldState }) => (
                            <FormSelectInput
                              style={{
                                width: '20vw',
                                height: '5.5vh',
                              }}
                              {...field}
                              placeholder={item.placeholder}
                              options={item!.options!}
                              onChanged={(e) =>
                                setValue('legalNature', e.target.value)
                              }
                              error={fieldState.error?.message}
                            />
                          )}
                        />
                      )}
                      {!item.isDropdown && (
                        <Controller
                          name={item.id as any}
                          control={control}
                          render={({ field, fieldState }) => (
                            <FormInput
                              onChangeText={(e) => field.onChange(e)}
                              style={{
                                width: '20vw',
                                height: '5.5vh',
                              }}
                              autoFocus
                              placeholder={item.placeholder}
                              required
                              {...field}
                              mask={
                                field?.value?.length > 0 ? item.mask : undefined
                              }
                              errorMessage={fieldState.error?.message}
                            />
                          )}
                        />
                      )}
                      <Controller
                        name={fields[index + 1].id as any}
                        control={control}
                        render={({ field, fieldState }) => (
                          <FormInput
                            autoFocus
                            onChangeText={(e) => field.onChange(e)}
                            style={{
                              width: '20vw',
                              height: '5.5vh',
                            }}
                            placeholder={fields[index + 1].placeholder}
                            required
                            {...field}
                            mask={
                              field?.value?.length > 0
                                ? fields[index + 1].mask
                                : undefined
                            }
                            errorMessage={fieldState.error?.message}
                          />
                        )}
                      />
                    </div>
                  )}
                </div>
              )
            })}
            <div className="flex flex-col w-full gap-2 items-center justify-between mt-4">
              <button
                className="bg-white h-16 w-full border border-zinc-300 rounded-md font-bold"
                onClick={handleSubmit(onSubmit)}
              >
                Próximo
              </button>
              <button
                className="bg-zinc-900 h-16 w-full border border-zinc-300 rounded-md font-bold text-white"
                onClick={() =>
                  navigate('/create-account-wallet/choose-account-type')
                }
              >
                Voltar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

const fields = [
  {
    id: 'cnpj',
    placeholder: 'CNPJ',
    breakPoint: false,
    mask: '99.999.999/9999-99',
  },
  {
    id: 'email',
    placeholder: 'Email',
    breakPoint: false,
  },
  {
    id: 'companyName',
    placeholder: 'Razão Social',
    breakPoint: false,
  },
  {
    id: 'fantasyName',
    placeholder: 'Nome fantasia',
    breakPoint: false,
  },
  {
    id: 'phone',
    placeholder: 'Telefone',
    mask: '(99) 99999-9999',
    breakPoint: true,
  },
  {
    id: 'foundationDate',
    placeholder: 'Data de fundação',
    mask: '99/99/9999',
    breakPoint: undefined,
  },
  {
    id: 'legalNature',
    placeholder: 'Natureza jurídica',
    breakPoint: true,
    isDropdown: true,
    options: ['SA', 'LTDA', 'SS', 'ME', 'EPP', 'MEI', 'EIRELI'],
  },
  {
    id: 'CNAE',
    placeholder: 'CNAE',
    mask: '9999-9/99',
    breakPoint: undefined,
  },
  {
    id: 'monthlyRevenue',
    placeholder: 'Receita média mensal (R$0,00)',
    breakPoint: true,
    mask: 'currency',
  },
  {
    id: 'patrimony',
    placeholder: 'Patrimonio (R$0,00)',
    mask: 'currency',
    breakPoint: undefined,
  },
  {
    id: 'shareCapital',
    placeholder: 'Capital Social (R$0,00)',
    breakPoint: true,
    mask: 'currency',
  },
  {
    id: 'monthlyBilling',
    placeholder: 'Faturamento Mensal (R$0,00)',
    mask: 'currency',
    breakPoint: undefined,
  },
]
